import {Blog,Features,Footer,Header,Possibility,WhatGPT3} from '../container';
function Company(){
    return (
        <div className='App'>
      
        <Features/>
        </div>
    )
}

export default Company
